import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { IntercultureResultMapsPage } from '@interculture';

export const Route = createFileRoute(
  '/_app/interculture_/$crop/$formId/result/maps',
)({
  component: IntercultureResultMapsPage,
});
